import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Checkbox } from '../../../../../common/html/checkbox'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { DEFAULT_REPORT_TITLE, MAIN_SCREEN } from '../../../constant'
import classes from '../index.module.scss'
import {
  changeIsHasCompanyName,
  changeIsHasPortName,
  changeIsHasReportSubtitle,
  changeReportSubtitle,
  changeReportTitle,
  resetDefaultCoverPage,
  selectCount,
  selectIsHasCompanyName,
  selectIsHasPortName,
  selectIsHasReportSubtitle,
  selectReportSubtitle,
  selectReportTitle,
} from '../store/slice'

const MAX_LENGTH_SUBTITLE = 1300
const MAX_TITLE = 150

const CoverPage = () => {
  const dispatch = useDispatch()

  const plh = UseI18n('dynamicReport.PLH_NOTE')

  const title = useSelector(selectReportTitle)
  const isHasReportSubtitle = useSelector(selectIsHasReportSubtitle)
  const reportSubtitle = useSelector(selectReportSubtitle)
  const isHasCompanyName = useSelector(selectIsHasCompanyName)
  const isHasPortName = useSelector(selectIsHasPortName)
  const countC = useSelector(selectCount(MAIN_SCREEN.COMPANY_ANALYSIS)) || 0
  const countP = useSelector(selectCount(MAIN_SCREEN.PORTFOLIO_INSIGHT)) || 0

  const [isFocus, setIsFocus] = useState(false)
  const [isShowPopupReset, setIsShowPopupReset] = useState(false)

  const onChangeIsHasReportSubtitle = (val) => {
    dispatch(changeIsHasReportSubtitle(val))
  }

  const onChangeReportSubtitle = (e) => {
    const value = e.target.value
    if (value.length <= MAX_LENGTH_SUBTITLE) {
      dispatch(changeReportSubtitle(value))
    }
  }

  const onChangeReportTitle = (e) => {
    const value = e.target.value
    if (value.length <= MAX_TITLE) {
      dispatch(changeReportTitle(value))
    }
  }

  const onChangeIsHasCompanyName = (val) => {
    dispatch(changeIsHasCompanyName(val))
  }

  const onChangeIsHasPortName = (val) => {
    dispatch(changeIsHasPortName(val))
  }

  const blurInputTitle = () => {
    if (!title.trim()) {
      dispatch(changeReportTitle(''))
    }
    setIsFocus(false)
  }

  const focusInputTitle = () => {
    setIsFocus(true)
  }

  const setDefault = () => {
    dispatch(resetDefaultCoverPage())
    setIsShowPopupReset(false)
  }

  const valueTitle = !isFocus && !title.trim() ? DEFAULT_REPORT_TITLE : title

  useEffect(() => {
    if (!countC) {
      dispatch(changeIsHasCompanyName(false))
    }
    if (!countP) {
      dispatch(changeIsHasPortName(false))
    }
  }, [countC, countP])

  return (
    <div className={classes.panelList}>
      <div className="dFlex alignItemsCenter">
        <Element
          style={{ fontSize: 14, color: '#191D25' }}
          className={`${classes.title} w100`}
        >
          <Translate value={'dynamicReport.COVER_PAGE'} />
        </Element>
        <Element
          style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
          className={classes.btnReset}
          onClick={() => setIsShowPopupReset(true)}
        >
          <Icon
            style={{ color: '#0553A5', fontSize: 13 }}
            className="icon-reset2"
          />
          <Translate value="preferenceSetting.RESET" />
        </Element>
      </div>
      <div className={`${classes.note} pt1`}>
        <Translate value="financialAnalysis.PANEL_SETTING_NOTE" />
      </div>
      <div className={classes.contentSetting}>
        <div className={classes.scrollContainer}>
          <Element
            className={classes.notePanel}
            style={{ background: '#F3F3F3' }}
          >
            <div className="dFlex justifyContentBetween">
              <Translate className="fw600" value="dynamicReport.REPORT_TITLE" />
              <Element className="fstItalic" style={{ color: '#9C9C9C' }}>
                <Translate value="dynamicReport.MAX_REPORT_TITLE_CHARACTER" />
              </Element>
            </div>
            <Element
              elementName="textarea"
              style={{ border: '1px solid #E0E0E0', color: '#3A414B' }}
              className={classes.textareaCoverPage}
              onChange={onChangeReportTitle}
              value={valueTitle}
              onBlur={blurInputTitle}
              onFocus={focusInputTitle}
            />
          </Element>

          <div className={classes.selectType}>
            <div className="dFlex justifyContentBetween">
              <Checkbox
                title="dynamicReport.COMPANY_NAME"
                isI18n
                style={{ paddingLeft: 6, fontWeight: 600 }}
                checked={isHasCompanyName}
                onChange={onChangeIsHasCompanyName}
                isCheckOnClickText
                allowChange={!!countC}
              />
            </div>
            <div className="dFlex justifyContentBetween">
              <Checkbox
                title="dynamicReport.PORT_NAME"
                isI18n
                style={{ paddingLeft: 6, fontWeight: 600 }}
                checked={isHasPortName}
                onChange={onChangeIsHasPortName}
                isCheckOnClickText
                allowChange={!!countP}
              />
            </div>
          </div>

          <Element
            className={classes.notePanel}
            style={{ background: '#F3F3F3' }}
          >
            <div className="dFlex justifyContentBetween">
              <Checkbox
                title="dynamicReport.SUBTITLE"
                isI18n
                style={{ paddingLeft: 6, fontWeight: 600 }}
                checked={isHasReportSubtitle}
                onChange={onChangeIsHasReportSubtitle}
                isCheckOnClickText
              />
              <Element className="fstItalic" style={{ color: '#9C9C9C' }}>
                <Translate value="dynamicReport.MAX_NOTE_CHARACTER" />
              </Element>
            </div>
            <Element
              elementName="textarea"
              style={{ border: '1px solid #E0E0E0', color: '#3A414B' }}
              className={classes.textarea}
              placeholder={plh}
              onChange={onChangeReportSubtitle}
              value={reportSubtitle}
            />
          </Element>
        </div>
      </div>
      <PopupAction
        isShow={isShowPopupReset}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={() => setIsShowPopupReset(false)}
        btnCancel={{
          label: 'common.NO',
          event: () => setIsShowPopupReset(false),
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: setDefault,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.RESET_TEMPLATE" />
      </PopupAction>
    </div>
  )
}

export default CoverPage
